
import { getActions, getGlobal } from "../../../global";

import React, { FC, useEffect, useState, memo } from "../../../lib/teact/teact";
import { MessageList } from "../../../types";

import { copyTextToClipboard } from "../../../util/clipboard";
import Button from "../../ui/Button";
import Modal from "../../ui/Modal";
import { DBManager } from "../db/dbManager";
import { SendTeleMessage } from "../tdlib/tdlib";
import Snackbar from "../ui/snackbar";
import { parseMessageManual } from "./CanChuyenLib";
import './SendMessages.scss'
import { functionQueue } from "./functionQueue";
type OwnProps = {
    isOpen: boolean;
    onClose: () => void;
    messages: string[];
    sendTo: number;
    parentState: any,
}

const SendMessages: FC<OwnProps> = ({
    isOpen,
    onClose,
    messages,
    sendTo,
    parentState
}) => {
    const {
        sendMessage,

    } = getActions();
    const [state, setState] = useState({
        snackbarText: "",
        snackbarOpen: false,
    })
    function handleOnClose() {
        onClose()
    }
    async function handleSendTelegram(text: string) {
        const db = await DBManager.getDBConnection()
        const trans = db.transaction("contacts", "readonly")
        const obj = trans.objectStore("contacts")
        const request = obj.get(sendTo)
        request.onsuccess = () => {
            const result = request.result
            if (result) {
                const userId = result.tlUserId;
                const global = getGlobal()
                if (text.trim() != "" && userId!='0') {
                    SendTeleMessage(text, userId, sendMessage)
                    let msg = `Đã gửi tin nhắn tới ${userId}`
                    if (global.chats.byId[userId])
                        msg = "Đã gửi tin nhắn tới " + global.chats.byId[userId].title
                    msg += ". " + text.substring(0, 20)
                    showSnackbar(msg)
                } else {
                    const msg =`Không thể gửi tin nhắn: TelegramId :${userId}`;
                    showSnackbar(msg);
                }
                // } else {
                //     showSnackbar("Không tìm thấy hội thoại, hãy đảm bảo hội thoại tồn tại và đã cập nhật telegramID ở danh bạ")
                // }

            }
        }
    }
    function handleShare(text: string, title: string) {
        if (navigator.share) {

            navigator.share({
                title: title,
                text: text,
            })
        } else {
            showSnackbar('Trình duyệt của bạn không hỗ trợ tính năng chia sẻ, đã copy vào bộ nhớ')
            copyTextToClipboard(text)
        }
    }
    function showSnackbar(text: string) {
        setState(prev => ({ ...prev, snackbarOpen: true, snackbarText: text }))
    }
    function handleSParsemessage(item: any) {
        const msg = { text: item, contactId: sendTo, curMien: parentState.curMien, type: 2, date: parentState.workDate }
        console.log(parentState)
        parseMessageManual(msg)
    }
    return (
        <Modal onClose={onClose}
            title={"Gửi tin"}
            isOpen={isOpen}
            hasCloseButton
            className="main-modal"
        >
            <div className="msg-list-container">

                {
                    messages.map((item, index) => {
                        return (
                            <div className="msg-container" key={"msg-" + index}>
                                <div className="msg-content">
                                    {item}
                                </div>
                                <div className="send-right-panel">
                                    <div>
                                        <Button size="smaller" round
                                            onClick={() => handleSParsemessage(item)}
                                        ><i className=" fa-solid fa-floppy-disk"></i></Button>
                                    </div>
                                    <div>
                                        <Button size="smaller" round
                                            onClick={() => handleSendTelegram(item)}
                                        ><i className="icon icon-send-outline"></i></Button>
                                    </div>
                                    <div>
                                        <Button size="smaller" round
                                            onClick={() => handleShare(item, "gửi tin")}
                                        ><i className="fa-solid fa-share"></i></Button>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            {/* <div>
                <Button round
                    onClick={handleOnClose}> <i className="icon icon-close"></i></Button>
            </div> */}
            <Snackbar message={state.snackbarText} isOpen={state.snackbarOpen} triggerTime=""
                onClose={() => { setState({ ...state, snackbarOpen: false }) }}
            ></Snackbar>
        </Modal>
    )
}

export default memo(SendMessages)